<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/110Lmua/tc-custom/9781788630344.jpg?1705011455433" alt="This image is the cover for the book Face of Eve, The Lu Wilmott Sagas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Face of Eve, The Lu Wilmott Sagas
      </h1>
      <p class="bookDescription body article font2">
        <p>  <b>From a British novelist acclaimed for her strong heroines and “good writing” filled with “human insight,” a woman spies for the Allied forces during WWII (<i>The </i><i>Irish Press</i>).</b><br/><br/> One woman’s passionate courage during World War II<br/>  <br/> When Eve left her hometown of Portsmouth, she’d never intended to return. But now she has a confidence and maturity far beyond her years.<br/><br/> This makes her a very attractive prospect to David Hatton, charged with selecting highly unusual, independent, and intelligent candidates for the Special Operations Executive. For in the war that lies ahead, brute force won’t be enough.<br/><br/> Eve becomes part of the Second World War in a way that few others could manage. And when the time for role-playing and secrecy is over, who can say which is the real face of Eve?<br/><br/> The extraordinary conclusion to Betty Burton’s captivating Lu Wilmott novels.<br/>  <br/>  “It is encouraging when someone like Betty Burton manages against the odds to become a roaring success.” —<i>The </i><i>Guardian</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Betty Burton
      </h2>
      
      <p class="authorDescription body article"><P>Betty Burton was the author of many bestselling novels and short stories, including <I>The Girl Now Leaving</I>, <I>Not Just A Soldier’s War</I>, <I>The Face of Eve</I> and <I>The Consequences of War</I>. She also wrote for television and radio, and won the Chichester Festival Theatre Award.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?728e6193